import { cn } from "@tokenterminal/core/utils/cn"
import type { HTMLAttributes } from "react"

const Container = ({
  className = "",
  ...props
}: HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      className={cn("w-[1240px] max-w-full mx-auto px-5", className)}
      {...props}
    />
  )
}

export default Container
